import InfoBannerBaseMessage from "./InfoBaseBannerMessage";

const OfflineRepBannerMessage = (): JSX.Element => {
    return (
        <InfoBannerBaseMessage>
            <b>Our Customer Solutions Specialists are currently offline.</b>{" "}
            Pepper, our automated assistant, is available 24/7 to help resolve
            your issue or answer your questions. Our live chat hours are Mon -
            Fri: 8 AM - 8 PM EST, Sat & Sun: 9 AM - 4 PM EST.
        </InfoBannerBaseMessage>
    );
};

export default OfflineRepBannerMessage;
